
import { gql } from '@apollo/client';

export const GET_BILL_INVOICES_BY_BILL_ID = gql`
  query GetBillInvoicesByBillId($billId: ID!) {
    getBillInvoicesByBillId(billId: $billId) {
      id
      invoiceNo
      externalInvoiceNo
      invoiceAmount
      currency
      invoiceDate
      invoicedAt
      status
      operatorName
      cancelReason
      cancelledAt
      cancelOperatorId
      createdAt
      updatedAt
    }
  }
`;

export const GET_BILL_INVOICE_BY_ID = gql`
  query GetBillInvoiceById($id: ID!) {
    getBillInvoiceById(id: $id) {
      id
      invoiceNo
      externalInvoiceNo
      invoiceAmount
      currency
      invoiceDate
      invoicedAt
      status
      operatorName
      cancelReason
      cancelledAt
      cancelOperatorId
      createdAt
      updatedAt
    }
  }
`;
